import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import './Services.css';

const Training = () => {
  const programs = [
    {
      level: 'Beginner',
      title: 'Beginner Training Program',
      description: 'The Beginner Training Program is ideal for newcomers and young players who are just starting their badminton journey. This program focuses on introducing the basics of the game in a friendly and supportive environment. Key highlights include learning the rules of badminton, correct grip and stance, basic footwork, simple stroke techniques, and coordination exercises. The program emphasizes fun-based learning while building confidence, discipline, and interest in the sport.',
      image: 'img/Beginner Training Program (1).jpg',
      link: '/Beginner-Training-Program',
    },
    {
      level: 'Intermediate',
      title: 'Intermediate Training Program',
      description: 'The Intermediate Training Program is designed for players who already have basic playing experience and want to enhance their skills. This program focuses on refining techniques and improving consistency during rallies. Players receive training in advanced strokes, improved footwork, shot placement, and tactical understanding of singles and doubles play.Regular practice matches and performance feedback help players develop better court awareness and match control.',
      image: 'img/Intermediate Training Program.jpg',
      link: '/Intermediate-Advanced-Training-Program',
    },
    {
      level: 'Training Program',
      title: 'Advanced & Competitive Training Program',
      description: 'This program is tailored for serious players aiming to compete at higher levels. It involves high-intensity training sessions that focus on advanced techniques, speed, stamina, and match strategies. Players are trained in tournament preparation, mental conditioning, pressure handling, and strategic gameplay. Fitness training and regular competitive practice are integral parts of this program, helping players perform confidently in tournaments.',
      image: 'img/Advanced & Competitive Training Program.jpg',
      link: '/Advanced-Competitive-Training-Program',
    },
    {
      level: 'Program',
      title: 'Youth Development Program',
      description: 'The Youth Development Program focuses on identifying and nurturing young talent at an early stage. Training is age-appropriate and designed to build strong fundamentals while encouraging discipline and sportsmanship. This program helps young players develop agility, coordination, confidence, and a competitive mindset. It also prepares them for school-level, district-level, and open tournaments.',
      image: 'img/Youth Development Program.jpg',
      link: '/Youth-Development-Program',
    },
    {
      level: 'Program',
      title: 'Personalized Training Program',
      description: 'Our Personalized Training Program is designed for players who need individual attention and customized coaching. Training plans are tailored according to a player’s strengths, weaknesses, and goals. This program is ideal for players focusing on specific skills such as footwork, smash technique, net play, or fitness improvement. One-on-one coaching ensures faster progress and targeted development.',
      image: 'img/Beginner Training Program (1).jpg',
      link: '/Personalized-Training-Program',
    },
    {
      level: 'Program',
      title: 'Fitness & Conditioning Program',
      description: 'Badminton demands high levels of physical fitness. Our Fitness & Conditioning Program supports all training levels by focusing on agility, endurance, strength, and flexibility. This program includes warm- up routines, speed drills, strength training, stretching exercises, and injury - prevention techniques.It helps players maintain peak physical condition and reduce the risk of injuries.',
      image: 'img/Fitness & Conditioning Training.jpg',
      link: '/Fitness-Conditioning-Program',
    },
    {
      level: 'Program',
      title: 'Recreational Training Program',
      description: 'This program is suitable for adults and working professionals who want to enjoy badminton while staying fit. It focuses on regular play, basic skill improvement, and overall fitness in a relaxed and enjoyable environment.',
      image: 'img/Recreational Training Program.jpg',
      link: '/Recreational-Training-Program',
    }
  ];

  return (
    <div className="training-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Training Programs</span>
            <h1>Expert Coaching</h1>
            <p>Professional training programs for all skill levels</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/services">Services</Link>
              <span>/</span>
              <span>Training</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Learn From The Best</span>
            <h2>Transform Your Game</h2>
            <p>
              Our certified coaches bring years of competitive and teaching experience
              to help you reach your badminton goals. From beginners to elite players,
              we have a program tailored for you.
            </p>
          </div>
        </div>
      </section>

      {/* Main Programs */}
      <section className="section programs-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Core Programs</span>
            <h2>Training Programs</h2>
          </div>
          <div className="programs-grid">
            {programs.map((program, index) => (
              <div className="program-card" key={index}>
                <div className="program-image">
                  <img src={program.image} alt={program.title} />
                </div>
                <div className="program-content">
                  <span className="program-level">{program.level}</span>
                  <h3>{program.title}</h3>
                  <p>{program.description}</p>
                  <div className="program-meta">
                    <Link to={program.link} className="btn btn-primary">
                      Learn More <FaArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Improve Your Game?</h2>
            <p>Contact us to discuss which program is right for you</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-white">Get Started</Link>
              <Link to="/staff" className="btn btn-outline-white">Meet Our Coaches</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Training;
